import { vservice } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import {
  ContentCampaignUpdatableAttributesResourceModel,
  ContentCampaignUpdatableAttributesResourceTypeInAdmin,
  ContentCampaignUpdatableAttributesResourceWithModel
} from '@/modules/content-campaign/models/content-campaign-resource.model'
import { AdminContentCampaignService } from '@/modules/content-campaign/services/admin-content-campaign.service'
import { Data } from '@/modules/shared/models/data'

@vservice()
export class ContentCampaignGetAttributesUseCase {
  public remoteData = RemoteData
    .notAsked<Data<ContentCampaignUpdatableAttributesResourceTypeInAdmin>>()

  constructor(
    private readonly service: AdminContentCampaignService
  ) {
  }

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get allData() {
    return this.remoteData.fold(
      () => null,
      value => value || null,
      value => value,
      (error, value) => value || null
    )
  }

  get data(): ContentCampaignUpdatableAttributesResourceModel {
    return this.allData.data
  }

  get statuses(): Pick<ContentCampaignUpdatableAttributesResourceWithModel, 'statuses'> {
    return this.allData.statuses
  }

  execute(contentCampaignId: number): RemoteData<Data<ContentCampaignUpdatableAttributesResourceTypeInAdmin>> {
    return this.remoteData.fromPromise(
      this.service.getUpdatableAttributes(contentCampaignId))
  }
}
